import { Dialog as MuiDialog, IconButton, styled } from '@mui/material';

export const StyledChatIconButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.light,
}));

export const Dialog = styled(MuiDialog, {
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size: { w: number; h: number } }>(({ fullScreen, size }) => ({
  pointerEvents: 'none',
  '& .MuiDialog-container': {
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    pointerEvents: 'none',
  },
  '& .MuiPaper-root': {
    pointerEvents: 'auto',
    border: '1px solid #dadde3',
    boxShadow: '0 12px 30px rgba(0, 0, 0, 0.18)',

    display: 'flex',
    flexDirection: 'column',
    ...(fullScreen
      ? {
          position: 'relative',
          borderRadius: 0,
          bottom: 0,
          right: 0,
          width: '100%',
          height: '100%',
          maxWidth: '100%',
          maxHeight: 'none',
        }
      : {
          width: size.w,
          height: size.h,
          maxWidth: 'calc(100vw - 40px)',
          maxHeight: 'calc(100vh - 40px)',
          position: 'fixed',
          margin: 0,
          borderRadius: '12px',
          bottom: 20,
          right: 20,
        }),
  },
}));

export const Resizer = styled('div')({
  position: 'absolute',
  top: '6px',
  left: '6px',
  width: '14px',
  height: '14px',
  cursor: 'nwse-resize',
  opacity: 0.7,
  borderRadius: '3px',
  background:
    'linear-gradient(135deg, rgba(0, 0, 0, 0.18) 0 50%, transparent 50% 100%), linear-gradient(135deg, transparent 0 50%, rgba(0, 0, 0, 0.06) 50% 100%)',
});

export const Messages = styled('div')({
  flex: '1 1 auto',
  padding: '0.85rem 0.95rem',
  overflow: 'auto',
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
});
